/**
 * Assets referenced by absolute URL from the IdPrism transactional email templates
 * (OTP, email-updated, password-changed). They are imported here only so webpack
 * emits them to images/email/; no application code renders them.
 */
const emailAssets: string[] = [
    require('./atoz-wordmark.png'),
    require('./atoz-app-icon.png'),
    require('./icon-google-play.png'),
    require('./icon-app-store.png'),
    require('./social-linkedin.png'),
    require('./social-instagram.png'),
    require('./social-x.png'),
    require('./social-youtube.png'),
];

export default emailAssets;
